import { IV3D } from '@/Interfaces/v3d';
import { $ } from '@/Engine/stateInstance';
import { boxDataProps } from '@/Interfaces/common';
import { BoxItem } from '@/Engine/Box';
import { Vector3 } from 'three';

declare let v3d: IV3D;
export const addBox = (boxData: boxDataProps) => {
    let box = $.boxes.find((box) => box.uuid === boxData.uuid);

    if (!box) {
        box = new BoxItem({
            ...boxData,
        });
        $.boxes.push(box);
    }

    $.app.scene.add(box.model);

    let restriction = false;

    if (boxData.position[0] - boxData.width/2 < 0) {
        boxData.position[0] = boxData.width/2;
        restriction = true;
    }

    if (boxData.position[0] + boxData.width/2 > $.room.width) {
        boxData.position[0] = $.room.width - boxData.width/2;
        restriction = true;
    }
    const zCorrection = 0.015;
    if (boxData.position[2] - boxData.depth/2 < zCorrection) {
        boxData.position[2] = boxData.depth/2 + zCorrection;
        restriction = true;
    }

    if (boxData.position[2] + boxData.depth/2 > $.room.depth) {
        boxData.position[2] = $.room.depth - boxData.depth/2;
        restriction = true;
    }
    // const oldPosition = box.position.clone();
    box.setDimensions(boxData.width, boxData.height, boxData.depth, boxData.floorHeight);
    box.position = (new Vector3(
        boxData.position[0],
        boxData.position[1],
        boxData.position[2],
    ));


    // door.computeObb();

    return box;
};
